import { MutationTree } from "vuex";
import { ARTICULO } from "../ventas/types";

type HistoricoMutationTree = MutationTree<ARTICULO>;

export const mutations: HistoricoMutationTree = {};
